import {DatePicker, Form, Select} from 'antd';
import theme from '../ordersTheme.module.scss';
import {UploadCSV} from 'components/uploadCSV';
import {instrumentKeyOptions} from 'pages/AssetManagement/modules/instrumentKeys';

export const BackOfficeFields = ({form}) => {
  return (
    <div className={theme.backOfficeFields}>
      <Form.Item
        initialValue={'PUBLIC_EQUITY'}
        name="instrumentKey"
        label="Instrument">
        <Select options={instrumentKeyOptions(['PUBLIC_EQUITY'])} />
      </Form.Item>
      <Form.Item
        name="historyUrl"
        label="History CSV"
        valuePropName="value"
        trigger="onChange"
        getValueFromEvent={v => v}
        rules={[{required: true, message: 'Please upload a CSV'}]}>
        <UploadCSV
          clear={() => form.setFieldsValue({historyUrl: undefined})}
          sampleLink="https://pub-f20debf3db1a40abaf01f62ea3a01c58.r2.dev/mdiho1758548998526hist.csv"
        />
      </Form.Item>
      <Form.Item
        name="statementUrl"
        label="Statement CSV"
        valuePropName="value"
        trigger="onChange"
        getValueFromEvent={v => v}
        rules={[{required: true, message: 'Please upload a CSV'}]}>
        <UploadCSV
          clear={() => form.setFieldsValue({statementUrl: undefined})}
          sampleLink="https://pub-f20debf3db1a40abaf01f62ea3a01c58.r2.dev/mdiho1758548998827stat.csv"
        />
      </Form.Item>
      <div className={theme.backOfficeDates}>
        <Form.Item
          name="startDate"
          rules={[{required: true, message: 'Please select a start date'}]}
          label="Start Date">
          <DatePicker allowClear showTime />
        </Form.Item>
        <Form.Item
          name="endDate"
          label="End Date"
          rules={[{required: true, message: 'Please select an end date'}]}>
          <DatePicker allowClear showTime />
        </Form.Item>
      </div>
    </div>
  );
};
